export default "__VITE_ASSET__BoCLVSxg__"